module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar uptool",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "请输入角色名",
      "prefix-icon": "el-icon-search",
      "size": "small"
    },
    model: {
      value: (_vm.SearchName),
      callback: function($$v) {
        _vm.SearchName = $$v
      },
      expression: "SearchName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.Limits.role_create) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.AddCharacter
    }
  }, [_vm._v("添加角色")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.Refresh
    }
  }, [_vm._v("刷新")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listloading),
      expression: "listloading"
    }],
    staticStyle: {
      "width": "99.9%"
    },
    attrs: {
      "data": _vm.List,
      "border": "",
      "max-height": _vm.maxHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "角色"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.Limits.role_view) ? _c('el-button', {
          staticStyle: {
            "padding": "7px"
          },
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.look(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看权限\n                ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.role_update) ? _c('el-button', {
          staticStyle: {
            "padding": "7px"
          },
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.change(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改权限\n                ")]) : _vm._e(), _vm._v(" "), (_vm.Limits.role_delete) ? _c('el-button', {
          staticStyle: {
            "padding": "7px"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.Delete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除角色\n                ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar downtool",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.Pagesize,
      "current-page": _vm.Curpage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "fullscreen": true,
      "title": "创建新角色",
      "visible": _vm.AddVisible,
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.AddVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写角色名称(必填)",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.CharacterName),
      callback: function($$v) {
        _vm.$set(_vm.form, "CharacterName", $$v)
      },
      expression: "form.CharacterName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.roledata.permissions), function(item) {
    return _c('el-form-item', {
      key: item.group,
      attrs: {
        "label": item.group,
        "label-width": _vm.formLabelWidth
      }
    }, [_c('el-checkbox-group', {
      model: {
        value: (_vm.form.role),
        callback: function($$v) {
          _vm.$set(_vm.form, "role", $$v)
        },
        expression: "form.role"
      }
    }, _vm._l((item.items), function(it) {
      return _c('el-checkbox', {
        key: it.value,
        attrs: {
          "label": it.value
        }
      }, [_vm._v(_vm._s(it.label) + "\n                    ")])
    }))], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "padding": "10px 50px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.createloading
    },
    on: {
      "click": _vm.UpCharacter
    }
  }, [_vm._v("提 交\n            ")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "fullscreen": true,
      "title": "权限详细",
      "visible": _vm.LookVisible,
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.LookVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写角色名称(必填)",
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.CharacterName),
      callback: function($$v) {
        _vm.$set(_vm.form2, "CharacterName", $$v)
      },
      expression: "form2.CharacterName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.roledata.permissions), function(item) {
    return _c('el-form-item', {
      key: item.group,
      attrs: {
        "label": item.group,
        "label-width": _vm.formLabelWidth
      }
    }, [_c('el-checkbox-group', {
      attrs: {
        "id": "box"
      },
      model: {
        value: (_vm.form2.role),
        callback: function($$v) {
          _vm.$set(_vm.form2, "role", $$v)
        },
        expression: "form2.role"
      }
    }, _vm._l((item.items), function(it) {
      return _c('el-checkbox', {
        key: it.value,
        attrs: {
          "label": it.value
        }
      }, [_vm._v(_vm._s(it.label) + "\n                    ")])
    }))], 1)
  })], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "fullscreen": true,
      "title": "修改角色权限",
      "visible": _vm.ChangeVisible,
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.ChangeVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form3
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写角色名称(必填)",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form3.CharacterName),
      callback: function($$v) {
        _vm.$set(_vm.form3, "CharacterName", $$v)
      },
      expression: "form3.CharacterName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.roledata.permissions), function(item) {
    return _c('el-form-item', {
      key: item.group,
      attrs: {
        "label": item.group,
        "label-width": _vm.formLabelWidth
      }
    }, [_c('el-checkbox-group', {
      model: {
        value: (_vm.form3.role),
        callback: function($$v) {
          _vm.$set(_vm.form3, "role", $$v)
        },
        expression: "form3.role"
      }
    }, _vm._l((item.items), function(it) {
      return _c('el-checkbox', {
        key: it.value,
        attrs: {
          "label": it.value
        }
      }, [_vm._v(_vm._s(it.label) + "\n                    ")])
    }))], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "padding": "10px 50px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.changeloading
    },
    on: {
      "click": _vm.ChangeCharacter
    }
  }, [_vm._v("确 认 修 改\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81954e3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RoleManage.vue
// module id = 1291
// module chunks = 1